import type { AccountLink, ProductKind, ProductStatus } from '../../bank-account-fields.types';

const formatLink = (link: Record<string, unknown>): AccountLink => {
  const productStatuses = (link.productStatuses as Record<string, Record<string, unknown>>) || {};

  return {
    accountIds: link.accountIds || [],
    errorCode: link.errorCode || null,
    isConnected: link.isConnected || null,
    linkId: link.linkId || null,
    linkState: link.linkState || null,
    productStatuses: Object.fromEntries(
      ['accountNumbers', 'accounts', 'identity', 'investments', 'transactions'].map(productKind => {
        const status = productStatuses?.[productKind] || {};
        return [
          productKind,
          {
            errorCode: status.errorCode || null,
            errorMessage: status.errorMessage || null,
            lastAttemptedAt: status.lastAttemptedAt || null,
            refreshedAt: status.refreshedAt || null,
            unavailable: status.unavailable || null,
          } as ProductStatus,
        ];
      }),
    ) as Record<ProductKind, ProductStatus>,
  } as AccountLink;
};

export default formatLink;
